import { gql } from 'graphql-tag';

export default gql`
  query GetUserOpenCreditsByAccount($input: GetUserCreditsInput!) {
    getUserOpenCreditsByAccount(input: $input) {
      count
      results {
        id
        user {
          id
          formatted_name
        }
        amount
        date
        reason
        issued_by {
          formatted_name
        }
        track_credit
        fee_credit
        original_amount
        transaction {
          id
        }
      }
    }
  }
`;
